import { Common } from '@thecvlb/design-system/lib/src';

import { BenefitsCheckResultsCardProps } from './benefitsCheckResultsCard.types';

const BenefitsCheckResultsCard: React.FC<BenefitsCheckResultsCardProps> = ({
  provider,
  notifyOnChange,
  toggleNotifyOnChange,
  insurancesAmount = 0,
  data = {
    coinsurance: 0,
    cost: 0,
    finalCost: 0,
    status: 'UNKNOWN'
  }
}) => {
  const { status, cost, coinsurance, finalCost } = data;
  const isPercentageDiscount = typeof coinsurance === 'number' && coinsurance > 0;
  const fixedOldPrice = cost ? `${(cost / 100).toFixed(cost % 1 !== 0 ? 2 : 0)}` : 'N/A';
  const fixedFinalPrice = finalCost
    ? `${(finalCost / 100).toFixed((finalCost / 100) % 1 !== 0 ? 2 : 0)}`
    : 'N/A';

  return (
    <>
      {['ACTIVE', 'ACTIVE_AT_RISK'].includes(status) ? (
        <div className="flex flex-col gap-3 rounded-2xl border border-gray-200 bg-gray-100 p-4">
          <div className="flex justify-between gap-2">
            <div>
              <h2 className="mb-2 text-mSm font-bold md:text-sm" data-testid="insurance_accepted">
                Your insurance has been accepted
              </h2>
              <div className="flex gap-1">
                <Common.Icon className="size-5 flex-none" name="shield-check-outline" />
                <p className="text-mSm md:text-sm">
                  Your estimated {isPercentageDiscount ? 'coinsurance' : 'copay'} is
                  {isPercentageDiscount ? ` ${coinsurance}%` : ` $${fixedFinalPrice}`} for this
                  telehealth appointment.
                  <span className="mx-0.5 text-gray">
                    {isPercentageDiscount ? 'Coinsurance' : 'Copay'} does not include cost of your
                    medication.
                  </span>
                </p>
              </div>
            </div>
            <Common.Icon className="size-6 flex-none text-green" name="check-circle" />
          </div>
          <div className="h-px w-full bg-gray"></div>
          <div className="flex items-start justify-between">
            <div className="flex flex-col">
              <span className="font-bold">Total</span>
              <span className="text-sm text-gray">with insurance</span>
            </div>
            <div className="flex items-center gap-1 text-mLg font-semibold">
              <span className="text-gray-400 line-through" data-testid="old_price">
                ${fixedOldPrice}
              </span>
              <span className="text-gray-600" data-testid="final_price">
                ${fixedFinalPrice}
              </span>
            </div>
          </div>
          {insurancesAmount > 0 && (
            <p className="text-mXs font-semibold text-gray-600">
              Note: Your secondary insurance may provide additional coverage.
            </p>
          )}
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-2 rounded-2xl border border-gray-200 bg-gray-100 p-4">
            <h2 className="text-mSm font-bold md:text-base">
              {status === 'INACTIVE'
                ? 'We do not currently accept your insurance'
                : 'We could not verify your primary insurance coverage'}
            </h2>
            <div className="flex gap-1">
              <Common.Icon className="text-red" name="close" />
              <span className="text-mSm text-gray">{provider}</span>
            </div>
          </div>
          <div className="flex flex-col gap-2 rounded-2xl border bg-primary-100 p-4 text-primary-700">
            <h3 className="font-bold">What happens if I proceed without insurance?</h3>
            <span className="text-mXs md:text-xs">
              We offer transparent pricing on all our services, ensuring you receive quality care at
              a clear cost.
            </span>
            {'INACTIVE' === status && (
              <Common.Checkbox
                checked={notifyOnChange}
                className="mt-2"
                color="blue"
                size="sm"
                onChange={toggleNotifyOnChange}
              >
                <span className="text-sm font-bold text-primary-700">
                  Notify me if coverage changes.
                </span>
              </Common.Checkbox>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default BenefitsCheckResultsCard;
